import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitAuthorityClaimMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  first_name: Types.Scalars['String']['input'];
  last_name: Types.Scalars['String']['input'];
  jurisdiction_id?: Types.InputMaybe<Types.Scalars['uuid']['input']>;
  new_jurisdiction?: Types.InputMaybe<Types.AuthorityClaimNewJurisdictionInput>;
  terms_accepted: Types.Scalars['Boolean']['input'];
  app_base_url: Types.Scalars['String']['input'];
}>;


export type SubmitAuthorityClaimMutation = { __typename?: 'mutation_root', submit_authority_claim: { __typename?: 'SubmitAuthorityClaimOutput', claim_id: any, status: string } };


export const SubmitAuthorityClaimDocument = gql`
    mutation SubmitAuthorityClaim($email: String!, $first_name: String!, $last_name: String!, $jurisdiction_id: uuid, $new_jurisdiction: AuthorityClaimNewJurisdictionInput, $terms_accepted: Boolean!, $app_base_url: String!) {
  submit_authority_claim(
    email: $email
    first_name: $first_name
    last_name: $last_name
    jurisdiction_id: $jurisdiction_id
    new_jurisdiction: $new_jurisdiction
    terms_accepted: $terms_accepted
    app_base_url: $app_base_url
  ) {
    claim_id
    status
  }
}
    `;
export type SubmitAuthorityClaimMutationFn = Apollo.MutationFunction<SubmitAuthorityClaimMutation, SubmitAuthorityClaimMutationVariables>;

/**
 * __useSubmitAuthorityClaimMutation__
 *
 * To run a mutation, you first call `useSubmitAuthorityClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAuthorityClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAuthorityClaimMutation, { data, loading, error }] = useSubmitAuthorityClaimMutation({
 *   variables: {
 *      email: // value for 'email'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      jurisdiction_id: // value for 'jurisdiction_id'
 *      new_jurisdiction: // value for 'new_jurisdiction'
 *      terms_accepted: // value for 'terms_accepted'
 *      app_base_url: // value for 'app_base_url'
 *   },
 * });
 */
export function useSubmitAuthorityClaimMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAuthorityClaimMutation, SubmitAuthorityClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAuthorityClaimMutation, SubmitAuthorityClaimMutationVariables>(SubmitAuthorityClaimDocument, options);
      }
export type SubmitAuthorityClaimMutationHookResult = ReturnType<typeof useSubmitAuthorityClaimMutation>;
export type SubmitAuthorityClaimMutationResult = Apollo.MutationResult<SubmitAuthorityClaimMutation>;
export type SubmitAuthorityClaimMutationOptions = Apollo.BaseMutationOptions<SubmitAuthorityClaimMutation, SubmitAuthorityClaimMutationVariables>;